
// function wgtPrintableImports(DashboardApiService) {
//     return {
//         templateUrl: '/directives/dashboard/widgets/wgtPrintableImports/wgtPrintableImports.tpl.html',
//         link: function ($scope, $element) {
//             $scope.isLoaded = false;
//             $scope.hasError = false;
//             $scope.loadWidget = loadWidget;
//             $scope.loadWidget(DashboardApiService, $scope);

//         }
//     };
// }

// function loadWidget(dashboardApiService, scope) {
//     dashboardApiService.getWidgetData(scope.item.name, scope.item.setting)
//     .then(function (response) {
//         var _data = response.data;
//         scope.transactionDate = _data[0].transactionDate;
//         scope.isLoaded = true;
//     }, function (response) {
//         scope.hasError = true;
//     });

// }

// angular.module('directives.dashboard')
//     .directive('wgtPrintableImports', wgtPrintableImports);


// angular.module('directives.dashboard').directive('wgtPrintableImports', ['DashboardApiService',
//     function (DashboardApiService) {
//         return {
//             templateUrl: 'directives/dashboard/widgets/wgtPrintableImports/wgtPrintableImports.tpl.html',
//             link: function ($scope, $element) {
//                 $scope.isLoaded = false;
//                 $scope.hasError = false;
//                 $scope.loadWidget = function () {
//                     DashboardApiService.getWidgetData($scope.item.name, $scope.item.setting)
//                         .then(function (response) {
//                             var _data = response.data;
//                             $scope.transactionDate = _data[0].transactionDate;
//                             $scope.isLoaded = true;
//                         }, function (response) {
//                             $scope.hasError = true;
//                         });
//                 };
//                 $scope.loadWidget();
//             }
//         };
//     }]
// );



angular
    .module('directives.dashboard')
    .directive('wgtPrintableImports', ['DashboardApiService', '$state', 'loadSpinnerService', 'FileDataImportApiServiceV2', 'ToasterService', '$translate', directiveFactory]);

// @ngInject
function directiveFactory (DashboardApiService, $state, loadSpinnerService, FileDataImportApiServiceV2, ToasterService, $translate) {
    return {
        templateUrl: 'directives/dashboard/widgets/wgtPrintableImports/wgtPrintableImports.tpl.html',
        link: function ($scope, $element) {
            $scope.isLoaded = false;
            $scope.hasError = false;
            $scope.loadWidget = function () {
                DashboardApiService.getWidgetData($scope.item.name, $scope.item.setting)
                    .then(function (response) {
                        var _data = response.data;
                        $scope.importFiles = _data;
                        $scope.isLoaded = true;
                    }, function (response) {
                        $scope.hasError = true;
                    });
            };
            $scope.gotoImportFile = function(id) {
                $state.go('product.productimporteditor', { importFileId: id });
            };
            $scope.printImportFile = function(id) {
                loadSpinnerService.start('mainSpinner');
                FileDataImportApiServiceV2.getPdfLabels(id, $scope.selectedLocationId).then(function(response) {
                    // Success, reload widget
                    $scope.loadWidget();
                },function(error) {
                    console.log(error);
                    if (error.status === 444) {
                        ToasterService.showInfo($translate.instant('widget.printable-imports.no-stock'));   
                        $scope.loadWidget(); 
                    } else {
                        ToasterService.showError($translate.instant('failure'));
                    }
                }).finally(function() {
                    loadSpinnerService.stop('mainSpinner');
                });
            };
            $scope.loadWidget();
        }
    };
}
